// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import { Button } from 'vant';

import {
  Collapse, CollapseItem, Col, Row, Tab, Tabs, Cell, CellGroup, Tabbar,
  TabbarItem,
  NavBar,
  Swipe,
  SwipeItem,
  DropdownMenu,
  DropdownItem, Popup, NoticeBar, Icon, Dialog, RadioGroup, Radio, Checkbox, CheckboxGroup,Toast,Form,Field

} from 'vant';

import '../static/global.css' /*引入公共样式*/

import router from './router'


Vue.use(Button);
Vue.use(Collapse);
Vue.use(CollapseItem);
Vue.use(Col);
Vue.use(Row);
Vue.use(Tab);
Vue.use(Tabs);
Vue.use(Cell);
Vue.use(CellGroup);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(Tabbar);
Vue.use(TabbarItem);
Vue.use(NavBar);
Vue.use(Swipe);
Vue.use(SwipeItem);
Vue.use(DropdownMenu);
Vue.use(DropdownItem);
Vue.use(Popup);
Vue.use(NoticeBar);
Vue.use(Icon);
Vue.use(Dialog);
Vue.use(RadioGroup);
Vue.use(Radio);
Vue.use(Toast);
Vue.use(Form );
Vue.use(Field );
Toast.setDefaultOptions({ duration: 3000 }); 
/* eslint-disable no-new */

router.beforeEach((to, from, next) => {
  if (to.meta.title) {
    // alert(to.meta.title)
    document.title = to.meta.title
    // alert(document.title)
  }
  next()
})

const app = new Vue({
  router,
  ...App,
})

.$mount('#app');




// WEBPACK FOOTER //
// ./src/main.js